import styled from 'styled-components';

export const Content = styled.div`
  width: 100%;
  background-color: #f5f7f9;
  border: 1px solid #f5f7f9;
  border-radius: 12px;
  padding: 40px 20px 5px 20px;
  h5 {
    font-size: 16px;
    line-height: 24px;
    color: #3d3d3d;
  }
  .wrap {
    margin-top: -10px;
    display: flex;
    gap: 20px;
  }
`;
export const Footer = styled.div`
  margin-top: 80px;
  p {
    font-size: 14px;
    padding: 1px 0;
    line-height: 20px;
    font-weight: 400;
    color: #667085;
  }

  span {
    font-size: 22px;
  }
`;
